import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingDepositUX = (props: any) => {
    return(
      <div
        id="CardBillingDepositUX-div-0"
        style={{ display: "flex", flexDirection: "column" }}>
        <div
          id="CardBillingDepositUX-div-1"
          style={{ display:  "flex", justifyContent: "space-between",  padding: "10px 10px 0px 10px"  }}>
          {}
          <div
            id="CardBillingDepositUX-div-6"
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            {props.languageUX === "en" ? "Accepting deposit payment" : "รับชำระเงินมัดจำ"}
            <div
              id="CardBillingDepositUX-div-51"
              style={{marginLeft: "50px", display: "none"}}>
              เลขที่ใบเสร็จ : 
            </div>
            <Label
              id="CardBillingDepositUX-Label-78"
              style={{marginLeft: "50px"}}>
              {props.receiptCode}
            </Label>
          </div>
        </div>
        <div
          id="CardBillingDepositUX-div-53"
          style={{padding: "0px 10px 10px 10px", display: props.viewMode ? "none" : "" }}>
          
          <hr
            id="CardBillingDepositUX-hr-54">
          </hr>
        </div>
        <div
          id="CardBillingDepositUX-div-181"
          style={{ margin: "0px 10px 15px" }}>
          {props.errorMessage}
        </div>
        <div
          className={props.rpsAddList}
          id="CardBillingDepositUX-div-79"
          style={{ margin: "0px 10px" }}>
          
          <Form
            id="CardBillingDepositUX-Form-80">
            <FormGroup
              className="rps-form-group"
              id="CardBillingDepositUX-FormGroup-81"
              inline={true}>
              <FormField
                id="CardBillingDepositUX-FormField-82"
                inline={true}
                style={{ width: "100%" }}
                width={props.isIpad ? 8 : 6}>
                <div
                  id="CardBillingDepositUX-div-84"
                  style={{ display: "flex",  width: "100%", alignItems: "center"  }}>
                  
                  <div
                    id="CardBillingDepositUX-div-86"
                    style={{ marginRight: "15px", width: "25%" }}>
                    {props.languageUX === "en" ? "Deposit List" : "รายการเงินมัดจำ"}
                  </div>
                  <div
                    id="CardBillingDepositUX-div-87"
                    style={{ width: "75%" }}>
                    
                    <Dropdown
                      disabled={props.selectDeposit?.receipt_no !== null}
                      fluid={true}
                      id="CardBillingDeposit-Dropdown-Wallet"
                      name="selectDeposit.id"
                      onChange={ props.onSelectWallet}
                      options={props.walletOptions}
                      selection={true}
                      value={props.selectDeposit?.id}>
                    </Dropdown>
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositUX-FormField-83"
                inline={true}
                width={props.isIpad ? 8 : 7}>
                <div
                  id="CardBillingDepositUX-div-85"
                  style={{ display: "flex",  width: "100%", alignItems: "center"  }}>
                  
                  <div
                    id="CardBillingDepositUX-div-89"
                    style={{ marginRight: "15px", width: "20%" }}>
                    {props.languageUX === "en" ? "Deposit Amount" : "ยอดเงินมัดจำ"}
                  </div>
                  <div
                    id="CardBillingDepositUX-div-90"
                    style={{ width: "50%" }}>
                    
                    <div
                      id="CardBillingDepositUX-div-162">
                      {props.inputWalletValue}
                    </div>
                  </div>
                  <div
                    id="CardBillingDepositUX-div-91"
                    style={{ marginLeft:   "15px", width: "30%" }}>
                    
                    <Button
                      color={props.selectDeposit?.mode_code !== "" && props.selectDeposit?.init_balance !== "0.00" ? "yellow" : "green"}
                      disabled={props.selectDeposit?.receipt_no !== null}
                      id="CardBillingDepositUX-Button-94"
                      onClick={props.onAddDeposit}>
                      {props.buttonAddDeposit}
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingDepositUX-div-95"
          style={{ display: "flex", margin: "20px 15px" }}>
          
          <div
            id="CardBillingDepositUX-div-111"
            style={{ width: "0%" }}>
            
          </div>
          <div
            id="CardBillingDepositUX-div-112"
            style={{ width: "100%" }}>
            
            <Table
              data={props.selectDepositData}
              headers="รหัส,รายการเงินมัดจำ,ราคา,ผู้ป่วยชำระ,ยอดตัดใข้,คงเหลือ"
              id="CardBillingDepositUX-Table-113"
              keys="code,mode_name,initBalanceFormat,patientPaidFormat,paymentFormat,balanceFormat"
              minRows="1"
              showPagination={false}
              widths="auto,^500,auto,auto">
            </Table>
          </div>
        </div>
        <div
          id="CardBillingDepositUX-div-96"
          style={{ margin: "0px 15px" }}>
          
          <Form
            id="CardBillingDepositUX-Form-98">
            <FormGroup
              id="CardBillingDepositUX-FormGroup-100"
              inline={true}
              style={{ display: "flex", justifyContent: "flex-end" }}>
              <FormField
                id="CardBillingDepositUX-FormField-106"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <div
                  id="CardBillingDepositUX-div-119"
                  style={{ width: "100%", fontWeight: "700" }}>
                  {props.languageUX === "en" ? "Total price" : "ราคารวม"}
                  <Input
                    id="CardBillingDeposit-Input-SumTotal"
                    value={props.sumWallet?.sumTotal}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositUX-FormField-108"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <div
                  id="CardBillingDepositUX-div-121"
                  style={{ width: "100%", fontWeight: "700" }}>
                  {props.languageUX === "en" ? "Patient payment" : "ผู้ป่วยชำระ"}
                  <Input
                    id="CardBillingDeposit-Input-SumPayable"
                    value={props.sumWallet?.sumPayable}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositUX-FormField-109"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <div
                  id="CardBillingDepositUX-div-122"
                  style={{ width: "100%", fontWeight: "700" }}>
                  {props.languageUX === "en" ? "Cut-off balance" : "ยอดตัดใช้"}
                  <Input
                    id="CardBillingDeposit-Input-SumAmount"
                    value={props.sumWallet?.sumAmount}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositUX-FormField-110"
                inline={true}
                width={props.isIpad ? 4 : 2}>
                <div
                  id="CardBillingDepositUX-div-123"
                  style={{ width: "100%", fontWeight: "700" }}>
                  {props.languageUX === "en" ? "remaining" : "คงเหลือ"}
                  <Input
                    id="CardBillingDeposit-Input-SumRemain"
                    value={props.sumWallet?.sumRemian}>
                  </Input>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBillingDepositUX-FormGroup-99"
              inline={true}
              style={{ display: "flex", justifyContent: "flex-end", ...(!props.isEdit && {display: "none"} ) }}>
              <FormField
                id="CardBillingDepositUX-FormField-157"
                inline={true}
                width={props.isIpad ? 10 : 6}>
                <div
                  id="CardBillingDepositUX-div-158"
                  style={{ display: "flex",  width: "100%", alignItems: "center", justifyContent: "flex-end"  }}>
                  
                  <div
                    id="CardBillingDepositUX-div-161"
                    style={{ fontWeight: "700", marginRight: "15px" }}>
                    {props.languageUX === "en" ? "Patient name on receipt" : "ชื่อผู้ป่วยบนใบเสร็จ"}
                  </div>
                  <div
                    id="CardBillingDepositUX-div-159">
                    
                    <Dropdown
                      id="CardBillingDepositUX-Dropdown-160"
                      onChange={props.onChangePatient}
                      options={props.patientOptions}
                      selection={true}
                      value={props.patientValue}>
                    </Dropdown>
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositUX-FormField-105"
                inline={true}
                style={{ display: "flex", justifyContent: "flex-end" }}
                width={props.isIpad ? 4 : 2}>
                <div
                  id="CardBillingDepositUX-div-118">
                  
                  <Button
                    color="green"
                    id="CardBillingDepositUX-Button-129"
                    onClick={props.billPayment}>
                    {props.languageUX === "en" ? "Receive payment" : "รับชำระเงิน"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBillingDepositUX-FormGroup-163"
              inline={true}
              style={{ ...(props.isEdit && {display: "none"} ) }}>
              <FormField
                id="CardBillingDepositUX-FormField-164"
                inline={true}
                width={8}>
                <div
                  id="CardBillingDepositUX-div-166"
                  style={{ display: "none" }}>
                  
                  <Button
                    color="yellow"
                    id="CardBillingDepositUX-Button-171"
                    size="small">
                    {props.languageUX === "en" ? "Details of the use of the deposit" : "รายละเอียดการใช้เงินมัดจำ"}
                  </Button>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositUX-FormField-165"
                inline={true}
                width={8}>
                <div
                  id="CardBillingDepositUX-div-167"
                  style={{ width: "100%", display: "flex", justifyContent: "space-between", }}>
                  
                  <div
                    id="CardBillingDepositUX-div-168">
                    
                    <Button
                      color="blue"
                      id="CardBillingDepositUX-Button-172"
                      onClick={props.onPrintDeposit}
                      size="small"
                      style={{ ...(props.selectDeposit?.status === "CANCELED" && { display: "none" }) }}>
                      {props.languageUX === "en" ? "Print a copy of the receipt" : "พิมพ์สำเนาใบเสร็จ"}
                    </Button>
                    <Button
                      color="blue"
                      id="CardBillingDepositUX-Button-175"
                      size="small"
                      style={{ display: "none" }}>
                      {props.languageUX === "en" ? "Print detail sheet" : "พิมพ์ใบแสดงรายละเอียด"}
                    </Button>
                  </div>
                  <div
                    id="CardBillingDepositUX-div-170">
                    
                    <Button
                      color="red"
                      id="CardBillingDepositUX-Button-174"
                      onClick={props.openCancelDeposit}
                      size="small"
                      style={{ ...(props.selectDeposit?.balance === "0.00" && { display: "none" }) }}>
                      {props.languageUX === "en" ? "Cancellation and refund of deposit" : "ยกเลิกและคืนเงินมัดจำ"}
                    </Button>
                    <Button
                      color="black"
                      id="CardBillingDepositUX-Button-182"
                      onClick={props.onCloseData}
                      size="small"
                      style={{ ...(props.selectDeposit?.receipt_no === "0.00" && { display: "none" }) }}>
                      {props.languageUX === "en" ? "Close the window" : "ปิดหน้าต่าง"}
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingDepositUX-div-130"
          style={{ display:  "flex", justifyContent: "space-between",  padding: "40px 10px 0px 10px"  }}>
          
          <div
            id="CardBillingDepositUX-div-132"
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            {props.languageUX === "en" ? "Deposit - History" : "ฝากเงิน - ประวัติ"}
          </div>
          <div
            id="CardBillingDepositUX-div-133"
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            {props.languageUX === "en" ? "Deposit payment history" : "ประวัติรับชำระเงินมัดจำ"}
          </div>
        </div>
        <div
          id="CardBillingDepositUX-div-131"
          style={{padding: "0px 10px 10px 10px", display: props.viewMode ? "none" : "" }}>
          
          <hr
            id="CardBillingDepositUX-hr-134">
          </hr>
        </div>
        <div
          className={props.rpsFilterBox}
          id="CardBillingDepositUX-div-135"
          style={{ margin: "0px 10px" }}>
          
          <Form
            id="CardBillingDepositUX-Form-138">
            <FormGroup
              className="rps-form-group"
              id="CardBillingDepositUX-FormGroup-139"
              inline={true}
              style={{ display: "flex" , justifyContent: props.isIpad ? "space-between" : "flex-end" }}>
              <FormField
                className="rps-form-field"
                id="CardBillingDepositUX-FormField-176"
                inline={true}>
                <div
                  id="CardBillingDepositUX-div-179"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Document code" : "รหัสเอกสาร"}
                </div>
              </FormField>
              <FormField
                className="rps-form-field"
                id="CardBillingDepositUX-FormField-177"
                inline={true}>
                <div
                  id="CardBillingDepositUX-div-178">
                  
                  <Input
                    id="CardBillingDeposit-Input-DepositCode"
                    name="depositCode"
                    onChange={ props.onChangeHistoryData}
                    value={props.depositCode}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="rps-form-field"
                id="CardBillingDepositUX-FormField-140"
                inline={true}>
                <div
                  id="CardBillingDepositUX-div-145"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "status" : "สถานะ"}
                </div>
              </FormField>
              <FormField
                className="rps-drop-down"
                id="CardBillingDepositUX-FormField-141"
                inline={true}
                width={3}>
                <div
                  id="CardBillingDepositUX-div-147"
                  style={{width: "100%"}}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardBillingDeposit-Dropdown-DepositStatus"
                    name="depositStatus"
                    onChange={ props.onChangeHistoryData}
                    options={props.depositStatusOptions}
                    selection={true}
                    value={props.depositStatus}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                className="rps-form-field full-width"
                id="CardBillingDepositUX-FormField-155"
                inline={true}>
                <div
                  id="CardBillingDepositUX-div-156"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Document issue date" : "วันที่ออกเอกสาร"}
                </div>
              </FormField>
              <FormField
                className="rps-date-text-box"
                id="CardBillingDepositUX-FormField-142"
                inline={true}
                width={props.isIpad ? 5 : 3}>
                <div
                  id="CardBillingDepositUX-div-148"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardBillingDeposit-DateTextBox-StartDate"
                    onChange={props.onChangeStartDate}
                    value={props.startDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                className="rps-date-text-box"
                id="CardBillingDepositUX-FormField-143"
                inline={true}
                width={props.isIpad ? 5 : 3}>
                <div
                  id="CardBillingDepositUX-div-149"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardBillingDeposit-DateTextBox-EndDate"
                    onChange={props.onChangeEndDate}
                    value={props.endDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                className="rps-form-field"
                id="CardBillingDepositUX-FormField-144"
                inline={true}>
                <div
                  id="CardBillingDepositUX-div-150">
                  {props.buttonSearchDepositHistory}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingDepositUX-div-136"
          style={{ margin: "0px 10px 30px 10px" }}>
          
          <Table
            data={props.depositHistoryData}
            getTrProps={props.selectDepositHistory}
            headers="ลำดับ, รหัสเอกสาร, สถานะ, วันที่,จำนวน, ยอดตัดใช้, คงเหลือ,เจ้าหน้าที่,"
            id="CardBillingDepositUX-Table-137"
            keys="no,code,status,created_datetime,initBalanceFormat,paymentFormat,balanceFormat,receipt_create_user,buttonDetail"
            minRows="5"
            showPagination={false}
            style={{ height: "300px" }}
            widths="auto,^220,^100,^100,auto,auto,auto,auto">
          </Table>
        </div>
      </div>
    )
}


export default CardBillingDepositUX

export const screenPropsDefault = {"by":"order","title":"MEDICAL FEE","titleDescription":"ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display:  \"flex\", justifyContent: \"space-between\",  padding: \"10px 10px 0px 10px\"  }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงินมัดจำ",
          "valueEN": "Accepting deposit payment"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จ : "
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"50px\", display: \"none\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 10px 10px\", display: props.viewMode ? \"none\" : \"\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "hr",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-hr-54"
        }
      },
      "seq": 54,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Label",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receiptCode"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Label-78"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"50px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "props.rpsAddList"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Form",
      "parent": 79,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Form-80"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormGroup",
      "parent": 80,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-group"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormGroup-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 8 : 6"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 8 : 7"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  width: \"100%\", alignItems: \"center\"  }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  width: \"100%\", alignItems: \"center\"  }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการเงินมัดจำ",
          "valueEN": "Deposit List"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"15px\", width: \"25%\" }"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"75%\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดเงินมัดจำ",
          "valueEN": "Deposit Amount"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"15px\", width: \"20%\" }"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:   \"15px\", width: \"30%\" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "Dropdown",
      "parent": 87,
      "props": {
        "clearable": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.selectDeposit?.receipt_no !== null"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Dropdown-Wallet"
        },
        "name": {
          "type": "value",
          "value": "selectDeposit.id"
        },
        "onChange": {
          "type": "code",
          "value": " props.onSelectWallet"
        },
        "options": {
          "type": "code",
          "value": "props.walletOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectDeposit?.id"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Button",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAddDeposit"
        },
        "color": {
          "type": "code",
          "value": "props.selectDeposit?.mode_code !== \"\" && props.selectDeposit?.init_balance !== \"0.00\" ? \"yellow\" : \"green\""
        },
        "disabled": {
          "type": "code",
          "value": "props.selectDeposit?.receipt_no !== null"
        },
        "icon": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-94"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddDeposit"
        },
        "size": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"20px 15px\" }"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 15px\" }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Form",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Form-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormGroup",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormGroup-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", ...(!props.isEdit && {display: \"none\"} ) }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormGroup",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormGroup-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 4 : 2"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"0%\" }"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 113,
      "name": "Table",
      "parent": 112,
      "props": {
        "data": {
          "type": "code",
          "value": "props.selectDepositData"
        },
        "headers": {
          "type": "value",
          "value": "รหัส,รายการเงินมัดจำ,ราคา,ผู้ป่วยชำระ,ยอดตัดใข้,คงเหลือ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Table-113"
        },
        "keys": {
          "type": "value",
          "value": "code,mode_name,initBalanceFormat,patientPaidFormat,paymentFormat,balanceFormat"
        },
        "minRows": {
          "type": "value",
          "value": "1"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "auto,^500,auto,auto"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-118"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", fontWeight: \"700\" }"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient payment"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", fontWeight: \"700\" }"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 109,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดตัดใช้",
          "valueEN": "Cut-off balance"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", fontWeight: \"700\" }"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "คงเหลือ",
          "valueEN": "remaining"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", fontWeight: \"700\" }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "Input",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Input-SumTotal"
        },
        "value": {
          "type": "code",
          "value": "props.sumWallet?.sumTotal"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "Input",
      "parent": 121,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Input-SumPayable"
        },
        "value": {
          "type": "code",
          "value": "props.sumWallet?.sumPayable"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "Input",
      "parent": 122,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Input-SumAmount"
        },
        "value": {
          "type": "code",
          "value": "props.sumWallet?.sumAmount"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "Input",
      "parent": 123,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Input-SumRemain"
        },
        "value": {
          "type": "code",
          "value": "props.sumWallet?.sumRemian"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Button",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน",
          "valueEN": "Receive payment"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-129"
        },
        "onClick": {
          "type": "code",
          "value": "props.billPayment"
        },
        "size": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{ display:  \"flex\", justifyContent: \"space-between\",  padding: \"40px 10px 0px 10px\"  }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 10px 10px\", display: props.viewMode ? \"none\" : \"\" }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "ฝากเงิน - ประวัติ",
          "valueEN": "Deposit - History"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติรับชำระเงินมัดจำ",
          "valueEN": "Deposit payment history"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "hr",
      "parent": 131,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-hr-134"
        }
      },
      "seq": 134,
      "void": true
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "props.rpsFilterBox"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px 30px 10px\" }"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 137,
      "name": "Table",
      "parent": 136,
      "props": {
        "data": {
          "type": "code",
          "value": "props.depositHistoryData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.selectDepositHistory"
        },
        "headers": {
          "type": "value",
          "value": "ลำดับ, รหัสเอกสาร, สถานะ, วันที่,จำนวน, ยอดตัดใช้, คงเหลือ,เจ้าหน้าที่,"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Table-137"
        },
        "keys": {
          "type": "value",
          "value": "no,code,status,created_datetime,initBalanceFormat,paymentFormat,balanceFormat,receipt_create_user,buttonDetail"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"300px\" }"
        },
        "widths": {
          "type": "value",
          "value": "auto,^220,^100,^100,auto,auto,auto,auto"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Form",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Form-138"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormGroup",
      "parent": 138,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-group"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormGroup-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" , justifyContent: props.isIpad ? \"space-between\" : \"flex-end\" }"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-field"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-drop-down"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-date-text-box"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 5 : 3"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-date-text-box"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 5 : 3"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-field"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-148"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearchDepositHistory"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 152,
      "name": "DateTextBox",
      "parent": 149,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-DateTextBox-EndDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 153,
      "name": "DateTextBox",
      "parent": 148,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-DateTextBox-StartDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "Dropdown",
      "parent": 147,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Dropdown-DepositStatus"
        },
        "name": {
          "type": "value",
          "value": "depositStatus"
        },
        "onChange": {
          "type": "code",
          "value": " props.onChangeHistoryData"
        },
        "options": {
          "type": "code",
          "value": "props.depositStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.depositStatus"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-field full-width"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-155"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ออกเอกสาร",
          "valueEN": "Document issue date"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "props.isIpad ? 10 : 6"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-158"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  width: \"100%\", alignItems: \"center\", justifyContent: \"flex-end\"  }"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-159"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Dropdown",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Dropdown-160"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePatient"
        },
        "options": {
          "type": "code",
          "value": "props.patientOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.patientValue"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ป่วยบนใบเสร็จ",
          "valueEN": "Patient name on receipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"700\", marginRight: \"15px\" }"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inputWalletValue",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-162"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "FormGroup",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormGroup-163"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isEdit && {display: \"none\"} ) }"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormField",
      "parent": 163,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-164"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 163,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-165"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-166"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", justifyContent: \"space-between\", }"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-168"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-170"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "Button",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการใช้เงินมัดจำ",
          "valueEN": "Details of the use of the deposit"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-171"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "Button",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์สำเนาใบเสร็จ",
          "valueEN": "Print a copy of the receipt"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-172"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintDeposit"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.selectDeposit?.status === \"CANCELED\" && { display: \"none\" }) }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "Button",
      "parent": 170,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกและคืนเงินมัดจำ",
          "valueEN": "Cancellation and refund of deposit"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-174"
        },
        "onClick": {
          "type": "code",
          "value": "props.openCancelDeposit"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.selectDeposit?.balance === \"0.00\" && { display: \"none\" }) }"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Button",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบแสดงรายละเอียด",
          "valueEN": "Print detail sheet"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-175"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-field"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-176"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "FormField",
      "parent": 139,
      "props": {
        "className": {
          "type": "value",
          "value": "rps-form-field"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-FormField-177"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 177,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-178"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสเอกสาร",
          "valueEN": "Document code"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-179"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "Input",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDeposit-Input-DepositCode"
        },
        "name": {
          "type": "value",
          "value": "depositCode"
        },
        "onChange": {
          "type": "code",
          "value": " props.onChangeHistoryData"
        },
        "value": {
          "type": "code",
          "value": "props.depositCode"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px 15px\" }"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Button",
      "parent": 170,
      "props": {
        "children": {
          "type": "value",
          "value": "ปิดหน้าต่าง",
          "valueEN": "Close the window"
        },
        "color": {
          "type": "value",
          "value": "black"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositUX-Button-182"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseData"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.selectDeposit?.receipt_no === \"0.00\" && { display: \"none\" }) }"
        }
      },
      "seq": 182,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingDepositUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "by": "order",
    "title": "MEDICAL FEE",
    "titleDescription": "ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"
  },
  "width": 80
}

*********************************************************************************** */
